import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { Route as rootRoute } from "./__root";

// Misma pantalla que /staff; existe solo para que «Agregar a Inicio» instale la app con el
// ícono y el nombre de «Profesor» (ver scripts/prerender-og.mjs y manifest-profesor.json).
export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/staff/profesor",
  component: lazyRouteComponent(() => import("./staff-page"), "StaffPage"),
});
